import intl from 'react-intl-universal';
import IntlPolyfill from 'intl';

if (typeof window === undefined) {
  global.Intl = IntlPolyfill;
}

export default intl.init.bind(intl);
